import { render, staticRenderFns } from "./BigMinBanner.vue?vue&type=template&id=6f9ea856&scoped=true&"
import script from "./BigMinBanner.vue?vue&type=script&lang=js&"
export * from "./BigMinBanner.vue?vue&type=script&lang=js&"
import style0 from "./BigMinBanner.vue?vue&type=style&index=0&id=6f9ea856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ea856",
  null
  
)

export default component.exports